import React from 'react';
import Modal from 'semantic-ui-react/dist/commonjs/modules/Modal';
import FocusLock from 'react-focus-lock';
import '@purple/semantic-ui-purple-theme/components/modal.css';
import './overrides.css';

export default class PurpleModal extends Modal {
  constructor(...args) {
    super(...args);
    this._extend('renderContent', 'wrapContent');
  }

  _extend(fnName, overrideFn) {
    const original = this[fnName];
    this[fnName] = (...args) => {
      const results = original(...args);
      return this[overrideFn](results, ...args);
    };
  }

  // eslint-disable-next-line class-methods-use-this
  wrapContent(children) {
    // need to wrap FocusLock in div because FocusLock creates multiple divs, and the click handler of semantic-ui gets confused
    return (
      <div>
        <FocusLock returnFocus autoFocus>
          {children}
        </FocusLock>
      </div>
    );
  }
}
